import {helpdeskQueries} from '@app/dashboard/helpdesk-queries';
import {shouldRevalidateDatatableLoader} from '@common/datatable/filters/utils/should-revalidate-datatable-loader';
import {queryClient} from '@common/http/query-client';
import {RouteObject} from 'react-router';

export const improvedButtonQuestionRoutes = (): RouteObject[] => {
  return [
    {
      path: 'improved-button-question',
      shouldRevalidate: shouldRevalidateDatatableLoader,
      lazy: () =>
        import(
          '@app/improved-button-question/datatable/improved-button-question-datatable-page'
        ),
      loader: async ({request}) => {
        const searchParams = Object.fromEntries(
          new URL(request.url).searchParams,
        );
        return await queryClient.ensureQueryData(
          helpdeskQueries.improvedButtonQuestion.index(searchParams),
        );
      },
    },
    {
      path: 'improved-button-question/new',
      lazy: () =>
        import(
          '@app/improved-button-question/datatable/create-improved-button-question-page'
        ),
    },
    {
      path: 'improved-button-question/:id/update',
      lazy: () =>
        import(
          '@app/improved-button-question/datatable/update-improved-button-question-page'
        ),
      loader: async ({params}) => {
        return await queryClient.ensureQueryData(
          helpdeskQueries.improvedButtonQuestion.get(params.id!),
        );
      },
    },
  ];
};